import {
  GetPlanCostSummaryOptions,
  getPlanCostSummary
} from '@dtx-company/inter-app/src/api/subscription-service/getPlanCostSummary'
import { PlanCostSummary } from '@dtx-company/inter-app/src/types/PlanCostSummary'
import {
  UseAPIConfig,
  UseAPIOptions,
  UseAPIResponse,
  useAPI
} from '@dtx-company/inter-app/src/hooks/useAPI'

type UsePlanCostSummaryOptions = UseAPIOptions<Omit<GetPlanCostSummaryOptions, 'version'>>
type UsePlanCostSummaryConfig = UseAPIConfig<PlanCostSummary, Error>
export type UsePlanCostSummaryResponse = UseAPIResponse<PlanCostSummary, Error>

/**
 * Wraps useSWR to retrieve a plan cost summary from the api.
 */
export function usePlanCostSummarySWR(
  options: UsePlanCostSummaryOptions,
  config?: UsePlanCostSummaryConfig
): UsePlanCostSummaryResponse {
  return useAPI<GetPlanCostSummaryOptions, PlanCostSummary, Error>(
    'usePlanCostSummarySWR',
    getPlanCostSummary,
    () => {
      const evaluatedOptions = typeof options === 'function' ? options() : options
      if (!evaluatedOptions) return
      return evaluatedOptions
    },
    config
  )
}
